import { createTheme } from '@mui/material/styles';

/**
 * Fabrique un thème MUI en fonction du mode demandé.
 * Les valeurs spécifiques au mode (couleurs primaires, fonds, tints des boîtes
 * décoratives) sont aussi exposées sous `palette.tints` pour que les composants
 * (CapacityBar par ex.) puissent piocher des fonds adaptés sans dur-coder.
 */
export function buildTheme(mode) {
  const isLight = mode === 'light';

  return createTheme({
    palette: {
      mode,
      primary: { main: isLight ? '#1565c0' : '#90caf9' },
      secondary: { main: isLight ? '#ef6c00' : '#ffb74d' },
      background: isLight
        ? { default: '#f6f7fb', paper: '#ffffff' }
        : { default: '#0e141b', paper: '#161d26' },
      // Palette décorative : fonds clairs / tamisés pour les Paper personnalisés.
      // - clientBg/Border : bloc « bonjour X » dans la home
      // - globalBg/Border : bloc capacité dans la home
      // - barTrack       : fond de la barre de progression empilée
      // - headerBg       : fond translucide de l'AppBar
      tints: isLight
        ? {
            clientBg: '#eef5ff',
            clientBorder: '#d6e4ff',
            globalBg: '#fff8e7',
            globalBorder: '#f3e6c4',
            barTrack: 'rgba(0,0,0,0.08)',
            headerBg: 'rgba(255,255,255,0.85)',
          }
        : {
            clientBg: 'rgba(144,202,249,0.10)',
            clientBorder: 'rgba(144,202,249,0.30)',
            globalBg: 'rgba(255,183,77,0.08)',
            globalBorder: 'rgba(255,183,77,0.25)',
            barTrack: 'rgba(255,255,255,0.10)',
            headerBg: 'rgba(22,29,38,0.85)',
          },
    },
    shape: { borderRadius: 14 },
    typography: {
      fontFamily:
        '"Inter", "Helvetica Neue", Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji", sans-serif',
      h1: { fontWeight: 800 },
      h2: { fontWeight: 800 },
      h3: { fontWeight: 700 },
      button: { textTransform: 'none', fontWeight: 600 },
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          rounded: { borderRadius: 18 },
        },
      },
      MuiButton: {
        defaultProps: { disableElevation: true },
      },
    },
  });
}

// Compat. : ancienne API `import theme from './theme.js'` (non-mode-aware) — on
// renvoie le thème dark par défaut pour les éventuels import non migrés.
const theme = buildTheme('dark');
export default theme;
